import { MantineProvider } from "@mantine/core";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import DashboardLayout from "./pages/App";
import { Home } from "./pages/Home";
import { Layout } from "./routes";
import { Error } from "./routes/Error";
import { PageNotFound } from "./routes/PageNotFound";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import { Notifications } from "@mantine/notifications";

const router = createBrowserRouter([
  {
    element: <Layout />,
    // error page for development
    // errorElement: <Error />,
    children: [
      { path: "/", element: <Home /> },
      // { path: "/signIn", element: <SignIn /> },
      // { path: "/signUp", element: <SignUp /> },
      { path: "*", element: <PageNotFound /> },
      // { path: "/app", element: <DashboardLayout /> },
    ],
  },
]);

export const App = () => (
  <>
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <Notifications position="top-right" />
      <RouterProvider router={router} />
    </MantineProvider>
  </>
);
